import { render } from "./IncomeAccounting.vue?vue&type=template&id=15bbfbb1&scoped=true"
import script from "./IncomeAccounting.vue?vue&type=script&lang=js"
export * from "./IncomeAccounting.vue?vue&type=script&lang=js"

import "./IncomeAccounting.vue?vue&type=style&index=0&id=15bbfbb1&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bbfbb1"]])

export default __exports__